// data/internal/useResourceController.ts
import { useLazyResource } from "./useLazyResource";
import { useSaveController } from "./useSaveController";

export function useResourceController<T>(
    loader: () => Promise<T>,
    saver: (data: T) => Promise<void>,
    deps: readonly unknown[] = []
) {
    const resource = useLazyResource(loader, deps);

    const saveController = useSaveController<T>(
        saver,
        updated => resource.setData(prev => prev ? { ...prev, ...updated } : updated)
    );

    return { ...resource, ...saveController };
}
